<template lang="html">
    <header >
      <a href="javascript:void(0);" class="slds-assistive-text slds-assistive-text_focus">Skip to Navigation</a>
      <a href="javascript:void(0);" class="slds-assistive-text slds-assistive-text_focus">Skip to Main Content</a>
      <div class="slds-global-header slds-grid slds-grid_align-spread">

        <div class="slds-global-header__item">
          <div class="mylogo"></div>
        </div>

        <div class="slds-global-header__item slds-global-header__item_search">

          <formfield
            v-if="$store.state.multizona"
            v-bind:title="sceltaZona.title"
            v-bind:type="sceltaZona.type"
            v-bind:name="sceltaZona.name"
            v-bind:value="$store.getters.zona"
            v-bind:placeholder="sceltaZona.placeholder"
            v-bind:tabindex="sceltaZona.tabindex"
            v-bind:disabled="sceltaZona.disabled"
            v-bind:options="zone"
            v-on:change="setField($event)"
          />


            <gnetLookup 
              v-if="false"
              v-bind:label="'Cerca'"
              v-bind:object="'Account'"
              v-bind:founded="founded"
              v-bind:selected="found"
              v-on:change="search"
              v-on:click="selected($event)"
            ></gnetLookup>
        </div>
        <div class="slds-global-header__item">
        </div>

        <div class="slds-global-header__item">
          <ul class="slds-global-actions">

            <li v-if="showTicket" class="slds-global-actions__item">
              <button class="slds-button slds-button_brand" v-on:click="$emit('ticket')">Ticket generico</button>
            </li>

            <li v-if="actionAdd" class="slds-global-actions__item">
              <div class="slds-dropdown-trigger slds-dropdown-trigger_click slds-is-open">
                <button v-on:click="$emit('add')" class="slds-button slds-button_icon slds-button_icon slds-button_icon-container slds-button_icon-small slds-global-actions__task slds-global-actions__item-action" aria-haspopup="true" title="Global Actions">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#add"></use>
                </svg>
                <span class="slds-assistive-text">Global Actions</span>
              </button>
              </div>
            </li>

            <gnetHeaderNotification v-bind:notifications="notifications" v-on:readed="readed($event)"></gnetHeaderNotification>

            <li class="slds-global-actions__item">
              <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
                <button v-on:click="avatar" class="slds-button slds-global-actions__avatar slds-global-actions__item-action" title="person name" aria-haspopup="true">
                  <span class="slds-avatar slds-avatar_circle slds-avatar_medium">
                    <img v-if="!$store.state.user.imageUrl" alt="Person name" src="/assets/images/avatar2.jpg" title="User avatar" />
                    <img v-if="$store.state.user.imageUrl" alt="Person name" v-bind:src="$store.state.user.imageUrl" title="User avatar" />
                  </span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </header>
</template>

<script>
import gnetLookup from './lookup.vue'
import gnetHeaderNotification from './headernotification.vue'
import formfield from './formfield.vue'

export default {
  name: 'gnetHeader',
  components: {
    gnetHeaderNotification,
    gnetLookup,
    formfield
  },
  props: {
    // zone: Array,
    logo: String,
    actionAdd: Boolean,
    showTicket: Boolean
  },
  data() {
    return {
      zone:[],
      sceltaZona: { id:1, title:'Zona', value: this.$store.getters.zona, name:'Zona', type:'picklist', placeholder:'Selezionare un codice zona', tabindex:1, disabled: false },

      founded: [],
      found:undefined,
      notifications:[
        /*
        {
          order: 1,
          title: 'messaggio 1',
          content:'sono il messaggio 1',
          datetime:'',
          who: 'Paolo',
          avatar: 'avatar1.jpg',
          unreaded:true,
        },
        {
          order: 2,
          title: 'messaggio 2',
          content:'sono il messaggio 2',
          datetime:'',
          who: 'Mario',
          avatar: '',
          unreaded:true,
        }
        */
      ],
      agenti:[
        // { codice:123, email: 'claudio.minnocci@fcp.it'},
        { codice:357, email: 'domenico.depace@fcp.it'},
        { codice:427, email: 'stefano.novelli@fcp.it'},
        { codice:460, email: 'salvatore.capobianco@fcp.it'},
        { codice:504, email: 'michelangelo.tranchida@fcp.it'},
        // { codice:541, email: 'loretta.lissandrin@fcp.it'},
        // { codice:545, email: 'carlo.voce@fcp.it'},
        { codice:546, email: 'francesco.vozza@fcp.it'},
        // { codice:553, email: 'emidio.marconi@fcp.it'},
        { codice:563, email: 'gianluca.paoli@fcp.it'},
        { codice:608, email: 'elio.pezzuto@fcp.it'},
        { codice:632, email: 'massimino.liberatore@fcp.it'},
        { codice:643, email: 'pietro.scariano@fcp.it'},
        { codice:644, email: 'davide.zinno@fcp.it'},
        { codice:654, email: 'antonio.defilippi@fcp.it'},
        { codice:669, email: 'andrea.quaggia@fcp.it'},
        { codice:677, email: 'maurizio.ravani@fcp.it'},
        { codice:678, email: 'giovanni.fornario@fcp.it'},
        // { codice:679, email: 'guido.denoni@fcp.it'},
        { codice:681, email: 'sergio.fornario@fcp.it'},
        { codice:682, email: 'raffaele.sgarangella@fcp.it'},
        // { codice:685, email: 'salvatore.zappala@fcp.it'},
        { codice:693, email: 'andrea.bernabe@fcp.it'},
        // { codice:695, email: 'riccardo.angelini@fcp.it'},
        { codice:696, email: 'gianluigi.andreatta@fcp.it'},
        { codice:697, email: 'giuseppe.martusciello@fcp.it'},
        { codice:698, email: 'michele.depace@fcp.it'},
        { codice:699, email: 'alberto.bianchi@fcp.it'},
        // { codice:701, email: 'andrea.derocchi@fcp.it'},
        { codice:703, email: 'amerigo.lizzani@fcp.it'},
        { codice:704, email: 'cesare.lamusta@fcp.it'},
        { codice:705, email: 'marco.frau@fcp.it'},
        // { codice:708, email: 'luca.zanettin@fcp.it'},
        { codice:709, email: 'costantino.battista@fcp.it'},
        // { codice:710, email: 'maurizio.salvan@fcp.it'},
        { codice:711, email: 'federico.massai@fcp.it'},
        { codice:712, email: 'simone.lamanna@fcp.it'},
        { codice:713, email: 'michele.cagnolini@fcp.it'},
        { codice:714, email: 'roberto.zuena@fcp.it'},
        { codice:715, email: 'tiziana.foppa@fcp.it'},
        { codice:716, email: 'simone.trombatore@fcp.it'},
        { codice:717, email: 'stefano.rivolta@fcp.it'},
        { codice:719, email: 'emanuele.voce@fcp.it'},
        { codice:720, email: 'davide.mosca@fcp.it'},
        { codice:721, email: 'federico.pampalone@fcp.it'},
        { codice:901, email: 'erica.birolini@fcp.it'},
        { codice:955, email: 'ilaria.limonta@fcp.it'},
        { codice:999, email: 'TUTTO'},
        { codice:991, email: 'AREA1W'},
        { codice:996, email: 'AREA1E'},
        { codice:992, email: 'AREA2NORD'},
        { codice:993, email: 'AREA2SUD'},
        { codice:994, email: 'AREA3'},
        { codice:995, email: 'AREA4'},
      ]
    }
  },
  mounted: function() {
    this.zone=this.calcolazone();
  },
  async created() {

  },
  computed: {

  },
  methods: {
    calcolazone: function() {
      var z=[];
      if (this.$store.getters.connection.userdata) {
        if (this.$store.getters.connection.userdata.agentcodes) {
          this.$store.getters.connection.userdata.agentcodes.forEach(function(c) {
            var i=this.agenti.findIndex(function(agente) {
              if (agente.codice==c) return true;
            });
            var nome=c;
            if (i>=0) nome=c+' - '+this.agenti[i].email;
            z.push( { label:nome, value:c } )
          }, this);
        }
      }
      console.log(z);
      return z;
    },
    setField: function(value) {
      console.log('setField:');
      console.log(value);
      this.$store.commit('SET_ZONA', value);
    },
    search: function() {
        this.founded=[
          /*
          {
            id:1,
            name:'uno',
            value:'ciao'
          },
          {
            id:2,
            name:'due',
            value:'bau'
          }
          */
        ];
    },
    selected: function(index) {
        console.log('selected:'+index);
        console.log(this.founded[index]);
    },
    avatar: function() {
      this.$store.dispatch('signOut');
    },
    readed: function(index) {
      console.log('readed');
      this.notifications[index].unreaded=false;
    }
  }
}
</script>

<style scoped>
.mylogo {
    width: 12.5rem;
    height: 2.5rem;
    background-image: url(/images/logo/app.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left center;
}
</style>
